const PUBLIC_SHELL_PRESETS = {
  standard: {
    layoutMaxWidth: "1440px",
    shellGutter: "clamp(16px, 2.1vw, 28px)",
    shellPaddingTop: "clamp(28px, 4vw, 48px)",
    shellPaddingBottom: "clamp(28px, 4vw, 56px)",
    navbarPaddingTop: "18px",
    navbarShellPaddingY: "14px",
    footerPaddingTop: "58px",
    footerPaddingBottom: "28px",
  },
  auth: {
    layoutMaxWidth: "1440px",
    shellGutter: "clamp(16px, 2.1vw, 28px)",
    shellPaddingTop: "clamp(28px, 4vw, 48px)",
    shellPaddingBottom: "clamp(28px, 4vw, 56px)",
    navbarPaddingTop: "18px",
    navbarShellPaddingY: "14px",
    footerPaddingTop: "0px",
    footerPaddingBottom: "28px",
  },
  listing: {
    layoutMaxWidth: "1440px",
    shellGutter: "clamp(16px, 2.1vw, 28px)",
    shellPaddingTop: "clamp(12px, 1.6vw, 20px)",
    shellPaddingBottom: "clamp(18px, 2vw, 24px)",
    navbarPaddingTop: "18px",
    navbarShellPaddingY: "14px",
    footerPaddingTop: "42px",
    footerPaddingBottom: "22px",
  },
};

function getPresetName({ mode = "marketing", shellPreset = "", pageClassName = "" }) {
  if (shellPreset && PUBLIC_SHELL_PRESETS[shellPreset]) {
    return shellPreset;
  }

  if (mode === "auth") {
    return "auth";
  }

  if (String(pageClassName).includes("public-job-marketplace-page")) {
    return "listing";
  }

  return "standard";
}

export function resolvePublicShellStyle({ mode, shellPreset, pageClassName }) {
  const presetName = getPresetName({ mode, shellPreset, pageClassName });
  const preset = PUBLIC_SHELL_PRESETS[presetName] || PUBLIC_SHELL_PRESETS.standard;

  return {
    "--public-layout-max-width": preset.layoutMaxWidth,
    "--public-shell-gutter": preset.shellGutter,
    "--public-layout-shell-padding-top": preset.shellPaddingTop,
    "--public-layout-shell-padding-bottom": preset.shellPaddingBottom,
    "--public-layout-navbar-padding-top": preset.navbarPaddingTop,
    "--public-layout-navbar-shell-padding-y": preset.navbarShellPaddingY,
    "--public-layout-footer-padding-top": preset.footerPaddingTop,
    "--public-layout-footer-padding-bottom": preset.footerPaddingBottom,
  };
}

export { PUBLIC_SHELL_PRESETS };
